/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "bf991032fb2938055f5b7e94e78e0368edf2891c";
